import { render, staticRenderFns } from "./JudgesExecutionTable.vue?vue&type=template&id=445f33b2&"
import script from "./JudgesExecutionTable.vue?vue&type=script&lang=js&"
export * from "./JudgesExecutionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports